import { Injectable } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationDialogService {

    private static readonly DELETE_MESSAGE_PREFIX = 'Are you sure you want to delete ';
    private static readonly EDIT_MESSAGE_PREFIX = 'Are you sure you want to edit ';

    private static readonly CONFIRM = 'Confirm';

    constructor(private modalService: NgbModal) { }

    private static deleteTemplate(a: string, b: string, c:string, d:string): string {
        return ConfirmationDialogService.DELETE_MESSAGE_PREFIX + `${a} ${b} ${c} ${d}?`;
    }

    private static editTemplate(a: string, b: string, c:string, d:string): string {
        return ConfirmationDialogService.EDIT_MESSAGE_PREFIX + `${a} ${b} ${c} ${d}?`;
    }

//Are you sure you want to delete the payment method ... associated with accounts ...?
//Are you sure you want to delete the recurring payment rule ... associated with account ...?

    public static getWalletDeleteMessage(nickname: string, accountNumbers: string) {
        return ConfirmationDialogService.deleteTemplate('the payment method',nickname, 'associated with accounts',accountNumbers);
    }

   public static getWalletEditMessage(nickname: string, accountNumbers: string) {
        return ConfirmationDialogService.editTemplate('the payment method',nickname, 'associated with accounts',accountNumbers)
    }

    public static getRuleDeleteMesage(accountNumbers: string) {
        return ConfirmationDialogService.deleteTemplate('the recurring payment rule','', 'associated with account',accountNumbers);
    }

    public confirm(
        message: string,
        btnOkText: string = ConfirmationDialogService.CONFIRM,
        btnCancelText: string = 'Cancel',
        dialogSize: 'sm' | 'md' = 'sm'): Promise<boolean> {
        const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize });
        modalRef.componentInstance.title = ConfirmationDialogService.CONFIRM;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;

        return modalRef.result;
    }

}
